import { TranslationKey } from "src/types/translationKey";
import { PayerId } from "@9amhealth/shared";

// PayerId now lives in @9amhealth/shared (single source of truth, also used by
// PMP). Re-exported here so existing `src/constants/payers` imports keep working.
export { PayerId };

/**
 * Employer partner UUIDs — identifies a member's direct employer.
 * Check via userState.isEmployerMember(EmployerId.X).
 */
export enum EmployerId {
  BANK_OF_NEW_YORK = "dd06daf1-7c80-4482-836b-634709e80fac",
  KWIK_TRIP = "287fcc30-03df-45f0-a00f-7f4b2814da0d"
}

/**
 * Maps payer IDs to their additional legal text translation keys.
 * Add new payers here when they require custom legal text on checkout.
 */
export const PayerAdditionalLegalTextKey: Partial<
  Record<PayerId, TranslationKey>
> = {};
